import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-black text-white">
      <SEO 
        title="Page Not Found - 404"
        description="The page you're looking for doesn't exist."
      />
      <Navbar />
      
      <div className="flex items-center justify-center min-h-[70vh] px-6">
        <div className="max-w-2xl mx-auto text-center">
          {/* 404 Display */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              404
            </h1>
          </div>

          {/* Message */}
          <h2 className="text-4xl font-bold mb-4">
            Page Not Found
          </h2>
          <p className="text-xl text-gray-400 mb-8">
            Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              onClick={() => navigate(-1)}
              variant="outline"
              className="border-2 border-gray-600 text-gray-200 hover:bg-gray-800"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Go Back
            </Button>
            <Button
              size="lg"
              onClick={() => navigate('/')}
              className="bg-blue-600 hover:bg-blue-700"
            >
              <Home className="w-5 h-5 mr-2" />
              Back to Home
            </Button>
          </div>

          {/* Helpful Links */}
          <div className="mt-12 pt-8 border-t border-gray-800">
            <p className="text-gray-400 mb-4">Popular pages:</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button
                onClick={() => navigate('/features')}
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                Features
              </button>
              <button
                onClick={() => navigate('/pricing')}
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                Pricing
              </button>
              <button
                onClick={() => navigate('/products/engine')}
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                Engine
              </button>
              <button
                onClick={() => navigate('/contact')}
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                Contact
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
